import React from "react";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Table } from "../../../components/CustomPaginations";
import { tableStyle } from "../../../components/TableStyle";

function PerformanceReportTable(props) {
	const {
		columns,
		tableData,
		pagerData,
		pageNum,
		numberOfItemsPerPage,
		receiveData,
		loading,
		defaultSorted,
		handleTableChange,
		flag,
		averageScrore,
		rowEvents,
	} = props;
	return (
		<>
			<PaginationProvider
				pagination={paginationFactory({
					custom: true,
					totalSize: props.pagerData ? props.pagerData.TotalCount : 0,
					page: pageNum,
					sizePerPage: numberOfItemsPerPage,
					paginationSize: numberOfItemsPerPage,
				})}
			>
				{({ paginationProps, paginationTableProps }) => {
					return (
						<>
							<Table
								inputValue={""}
								keyField={"id"}
								columns={columns}
								items={tableData}
								tableStyle={tableStyle}
								paginationProps={paginationProps}
								paginationTableProps={paginationTableProps}
								onTablePageChange={handleTableChange}
								defaultSorted={defaultSorted}
								showFeedback={false}
								tableLoader={loading}
								loading={loading}
								SearchBar={() => {
									return null;
								}}
								pagerData={pagerData}
								receiveData={(PageSize) => {
									receiveData(PageSize);
								}}
								flag={flag}
								flagTitle={"Average Score"}
								flagCount={averageScrore}
								rowEvents={rowEvents}
							/>
						</>
					);
				}}
			</PaginationProvider>
		</>
	);
}

export default PerformanceReportTable;
